var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3995 5.52858C24.3242 5.46974 24.2363 5.42886 24.1428 5.40906C24.0492 5.38925 23.9523 5.39104 23.8596 5.41429L17.3755 7.03531L10.8747 3.78489C10.7403 3.71785 10.5863 3.70111 10.4406 3.73771L3.73008 5.41534C3.59386 5.44902 3.47281 5.52727 3.38617 5.63765C3.29954 5.74804 3.2523 5.88421 3.25195 6.02453V21.1232C3.25195 21.2189 3.27375 21.3133 3.31571 21.3992C3.35767 21.4852 3.41868 21.5604 3.49409 21.6193C3.56951 21.6781 3.65735 21.719 3.75093 21.7388C3.84451 21.7585 3.94137 21.7567 4.03415 21.7335L10.5182 20.1124L17.019 23.3629C17.1534 23.4299 17.3074 23.4466 17.4531 23.41L24.1636 21.7324C24.2999 21.6987 24.4209 21.6205 24.5075 21.5101C24.5942 21.3997 24.6414 21.2635 24.6418 21.1232V6.02453C24.6417 5.92889 24.6199 5.83452 24.5779 5.74858C24.536 5.66264 24.475 5.5874 24.3995 5.52858ZM11.2207 5.36501L16.673 8.09117V21.7827L11.2207 19.0566V5.36501ZM4.51018 6.51839L9.96248 5.15531V18.9549L4.51018 20.318V6.51839ZM23.3835 20.6325L17.9312 21.9956V8.19287L23.3835 6.8298V20.6325Z",
    fill: "#404D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5d9c66bdb2d9a8b3fcdb69e048185101.svg";
export { ForwardRef as ReactComponent };